/* Core & libraries */
import React, { useEffect, useState } from "react";
import { useTheme } from "react-jss";
import { useLocation, useNavigate } from 'react-router-dom';
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
import { usePeopleService } from '../../../services/peopleService';
import { useAnalytics } from "../../../hooks/useAnalytics";
import { PAGE_TITLES } from "../../../constants/appConstants";
import { useHasPermission } from "hooks/useHasPermission";

/* Components */
import RemovedPeopleGrid from "./removedPeopleGrid/index.js";
import GridFilters from '../../ucgrid/filters';
import UCButton from "components/buttons";
import { ReactComponent as DownloadIcon } from "../../../resources/images/download-02.svg";

/* Styles */
import styles from "./styles.js"


const RemovedTab = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const location = useLocation();
  const navigate = useNavigate();
  const { checkPermission } = useHasPermission();

  const [gridOptions, setGridOptions] = useState(() => {
    const initialPage = location.pathname.includes('/removed')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    return {
      page: +initialPage,
      filters: {
        STATUS: [],
        ROLE: [],
      },
    };
  });

  const { peopleResponse, getPeopleList, searchPeople, gridActionPermision, downloadPeopleGridData } = usePeopleService();
  const { initAnalytics } = useAnalytics();
  const noRemovedPeopleData = peopleResponse?.results?.resultTotal <= 0

  useEffect(() => {
    getPeopleList(gridOptions, "REMOVED");
    gridOptions.page > 1 ? navigate(`/app/people/removed?page=${gridOptions.page}`) : navigate(`/app/people/removed`)
  }, [gridOptions]);

  useEffect(() => {
    const initUtagData = {
      channel: 'content',
      pageName: PAGE_TITLES["removedPeople"]
    };
    initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  useEffect(() => {
    const pageFromURL = location.pathname.includes('/removed')
      ? new URLSearchParams(location.search).get('page') || 1
      : 1;
    if (+pageFromURL !== gridOptions.page) {
      setGridOptions({ ...gridOptions, page: pageFromURL });
    }
  }, [location.search]);

  const handleDownloadRemovedPeopleGrid = () => {
    downloadPeopleGridData("REMOVED")
  }

  return (
    <div className={classes.peopleTab}>
      <div className={classes.filtersContainer}>
        <GridFilters
          response={peopleResponse}
          gridOptions={gridOptions}
          setGridOptions={setGridOptions}
          search={term => searchPeople(term, "REMOVED")}
          type='PEOPLE'
          disabled={Object.keys(peopleResponse).length === 0}
          className={classes.autocomplete}
        />
        {checkPermission('F_USERS_REPORT_DOWNLOAD') && (
          <UCButton
            onClick={handleDownloadRemovedPeopleGrid}
            type="default"
            text={<FormattedMessage id="people.grids.download" />}
            className={`${classes.downloadRemovedPeopleBtn} ${noRemovedPeopleData ? `${classes.downloadRemovedPeopleDisabledBtn}` : ``}`}
            icon={<DownloadIcon/>}
            loadingStateStyling={classes.downloadLoadingState}
            disabled={noRemovedPeopleData}
            spinnerClassName={classes.spinner}
            spinner={{
              name: "downloadRemovedPeopleGridData",
              size: 20
            }}
          />
        )}
      </div>
      <RemovedPeopleGrid
        peopleResponse={peopleResponse}
        gridOptions={gridOptions}
        setGridOptions={setGridOptions}
        gridActionPermision={gridActionPermision}
      />
    </div>
  )
}

export default RemovedTab;
